import { useCarrierIdentity } from "@/App/Auth/useCarrierIdentity";

/**
 * The carrier's own logo, at the start of every page header.
 *
 * Passed to Page's `leadingVisual`, which replaces the generic page icon. Every
 * screen in this portal is about one carrier's business with FreightSimple, and
 * their own mark says that faster than an icon does.
 *
 * The wide wordmark, not the small square mark: at page-header size the square
 * one is too cramped to read. Sized to match Hubble's carrier page so the same
 * brand reads identically to an operator and to the carrier themselves.
 *
 * A carrier with no logo asset falls back to the page's own icon rather than a
 * broken image: `onError` hides the img, and Page renders whatever it was given
 * underneath. Not every carrier identifier has a logo file.
 */
export function CarrierPageLogo() {
  const { carrierIdentifier, carrierName } = useCarrierIdentity();
  return (
    <img
      src={`/carrierLogos/${carrierIdentifier}.png`}
      alt={carrierName}
      title={carrierName}
      className="h-9 max-w-[170px] shrink-0 object-contain object-left"
      onError={(event) => {
        event.currentTarget.style.display = "none";
      }}
    />
  );
}
